import Vue from "vue";
import { Component } from "vue-property-decorator";
import { ActualiteDto } from "../../../../dto/GenApi.iNotPaie.Dto/ActualiteDto";
import { EventBus } from "../../../Controls/EventBus";
import EventConstants from "../../../Controls/EventConstants";
import { ServicesFactoryInstance } from "../../../Controls/ServicesFactory";
import DOMPurify from 'dompurify';

@Component({
	components: {
		ModalCardNews: require("../../modals/modalCardNews/modalCardNews.vue.html")
	}
})
export default class cardActivity extends Vue {
	public dataReady = false;
	public errorGetActu = false;
	public listeActualites: ActualiteDto[] = [];

	public mounted(): void {
		ServicesFactoryInstance.AccueilService.getActualites(data => {
			this.listeActualites = data.slice(0, 3);

			this.listeActualites.forEach(actualite => {
				if (actualite.Description != undefined) {
					actualite.Description = this.removeReadMore(actualite.Description);
					actualite.Description = DOMPurify.sanitize(actualite.Description);
				}
			});

			this.dataReady = true;
			this.errorGetActu = false;
		}, () => {
			this.dataReady = true;
			this.errorGetActu = true;
		});
	}

	public viewActualite(link: string): void {
		window.open(link, "_blank");
	}

	public openAideEnLigne(): void {
		EventBus.$emit(EventConstants.OPEN_AIDE_EN_LIGNE);
	}

	public removeReadMore(text: string): string {
		return text.replace(/<a\b[^>]*>(.*?)<\/a>/i, "");
	}
}



// WEBPACK FOOTER //
// ./src/components/home/cards/cardNews/cardNews.ts